import './style.css';

// todo use iframe when html content is seperately provided from backend
export function HtmlContent(props: { content: string }) {
  return (
    <div
      className="HtmlContent"
      dangerouslySetInnerHTML={{ __html: props.content }}
    />
  );
}
